import React, {useState} from 'react';
import {useStyles} from "./styles/InquiryStyle";
import {Box, Button, TextField} from "@material-ui/core";
import axios from "axios";

export default function Inquiry(props) {
    const classes = useStyles();
    const [email, setEmail] = useState('');
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');



    const handleSendInquiry = () => {

        const data = {
            email: email,
            title: title,
            content: content
        };

        if (!email || !title || !content) {
            alert('Please fill in all fields');
            return;
        }

        axios.post("/api/v1/user/inquiry", data)
            .then(response => {
                alert('Inquiry sent successfully')
                console.log("Inquiry sent successfully");
                window.location.reload();
            })
            .catch(error => {
                alert('Error sending inquiry')
                console.error("Error sending inquiry:", error);
            });
    }

    return (
        <Box className={classes.inquiryContainer}>
            <Box>
                <TextField
                    className={classes.textField}
                    fullWidth
                    label="Email"
                    variant="outlined"
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <TextField
                    className={classes.textField}
                    fullWidth
                    label="title"
                    variant="outlined"
                    required
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                />
                <TextField
                    className={classes.textField}
                    fullWidth
                    label="content"
                    variant="outlined"
                    multiline
                    minRows={4}
                    required
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                />
                <Button variant="contained" color="primary" onClick={handleSendInquiry}style={{width:100}}>
                    Submit
                </Button>
            </Box>
        </Box>
    );
}
